import React, { FC, useCallback, useMemo } from 'react';

import { SchedulingSection } from 'src/components/scheduling2';
import { RECIPIENT_LOOKUP_PAGE_SIZE } from 'src/components/scheduling2/EmailSettings.constants';
import { useGetTenantUsers } from 'src/hooks/queries/useGetTenantUsers';
import { IScheduledJobConfiguration } from 'src/interfaces/ScheduledJobConfiguration';
import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { usePropertySettings } from '../context';
import { setScheduling } from '../state';

import {
	getInactiveUserIds,
	toDraftScheduledJobConfiguration
} from './SchedulingSettingsV2.helpers';

export const SchedulingSettingsV2: FC = () => {
	const {
		state: { draft: property, original, errors },
		dispatch,
		isListMode
	} = usePropertySettings();

	const savedConfig = original?.scheduledJobConfiguration;
	const { data: tenantUsers } = useGetTenantUsers(undefined, RECIPIENT_LOOKUP_PAGE_SIZE);
	const inactiveUserIds = useMemo(() => getInactiveUserIds(tenantUsers), [tenantUsers]);

	const propertyError = useMemo(
		() => errors.find((e) => e.sectionId === SETTINGS_SECTION_TYPES.SCHEDULING),
		[errors]
	);

	const onConfigChange = useCallback(
		(config: IScheduledJobConfiguration): void => {
			dispatch(
				setScheduling(toDraftScheduledJobConfiguration(config, savedConfig, inactiveUserIds))
			);
		},
		[dispatch, savedConfig, inactiveUserIds]
	);

	return (
		<SchedulingSection
			initialConfig={property.scheduledJobConfiguration}
			onConfigChange={onConfigChange}
			error={propertyError}
			isListMode={isListMode}
		/>
	);
};
